import React from "react";

import {
  Link,
  useLocation,
} from "react-router-dom";

import {
  ShieldCheck,
  BriefcaseBusiness,
  Landmark,
  Users,
} from "lucide-react";

import "../styles/header.css";

import logo from "../assets/logo.png";

const Header = () => {

  const location =
    useLocation();

  const today =
    new Date().toLocaleDateString(
      "en-US",
      {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }
    );

  const navItems = [

    {
      path: "/insurance",
      label: "Insurance",
      icon: ShieldCheck,
    },

    {
      path: "/investors",
      label: "Investors",
      icon: Landmark,
    },

    {
      path: "/customers",
      label: "Customers",
      icon: Users,
    },

  ];

  return (

    <header className="rcs-modern-header">

      {/* LEFT */}

      <div className="rcs-modern-header-left">

        <Link
          to="/"
          className="rcs-modern-brand"
        >

          <img
            src={logo}
            alt="RCS Logo"
          />

        </Link>

      </div>

      {/* CENTER */}

      <nav className="rcs-modern-nav">

        {navItems.map(
          (item) => {

            const Icon =
              item.icon;

            return (

              <Link
                key={item.path}
                to={item.path}
                className={`rcs-modern-nav-link ${
                  location.pathname ===
                  item.path
                    ? "active"
                    : ""
                }`}
              >

                <Icon size={16} />

                {item.label}

              </Link>
            );
          }
        )}

      </nav>

      {/* RIGHT */}

      <div className="rcs-modern-header-right">

        <div className="rcs-modern-date">

          {today}

        </div>

      </div>

    </header>
  );
};

export default Header;